module.exports = __webpack_public_path__ + "static/media/no_courses.cf18d8f3.jpg";